module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.85949","quantity":0.00859},{"color":"#9dc4b5","label":" 0.85949- 0.85949","quantity":0.00859},{"color":"#e6efc3","label":" 0.85949- 0.85949","quantity":0.00859},{"color":"#ffe89e","label":" 0.85949- 0.96981","quantity":0.0097},{"color":"#f5af7f","label":" 0.96981- 1.61619","quantity":0.01616},{"color":"#ed6d32","label":" 1.61619- 13.2659","quantity":0.13266}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_70_return_20.json
// module id = tLzM
// module chunks = 171